import { render, staticRenderFns } from "./DiscountGood.vue?vue&type=template&id=71045b72&scoped=true&"
import script from "./DiscountGood.vue?vue&type=script&lang=js&"
export * from "./DiscountGood.vue?vue&type=script&lang=js&"
import style0 from "./DiscountGood.vue?vue&type=style&index=0&id=71045b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71045b72",
  null
  
)

export default component.exports